const applicationIdInitialState = '';

export default applicationIdInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/applicationIdInitialState.js